<template>
    <div class="container test-preview">
        <el-breadcrumb separator="/" style="margin:20px 0 10px 0">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/personal/bank' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>试卷预览</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card shadow="never" class="preview-header">
            <h1>{{examInfo.name}}</h1>
            <p>
                本试卷共
                <span>{{examInfo.content.length}}</span> 题,总分
                <span>{{examInfo.totalPoint}}</span> 分,考试时长
                <span>{{examInfo.duration}}</span> 分钟.
            </p>
        </el-card>
        <el-card shadow="never">
            <el-tabs type="border-card" @tab-click="handleClick" v-model="practiceType">
                <el-tab-pane :name="String(type.id)" v-for="type in showQuestionTypeList" :key="String(type.id)"
                    :label="`${type.name}(${questionAllList[String(type.id)].length})`"></el-tab-pane>
                <topicAll :questionType="practiceType" :questions="questionAllList[practiceType]"></topicAll>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
import topicAll from "./components/topic-all";
import { getEtexampaperDetail } from "@/api/exam/etexampaper";
import { getEtquestiontypeList } from "@/api/exam/etquestiontype";
import { formatQuestions } from "@/utils/exam";
export default {
    data () {
        return {
            data: [],
            examInfo: {
                content: []
            }, // 考试信息
            practiceType: "1",
            questionTypeList: [],
            questionAllList: {
                "1": []
            }
        };
    },
    components: {
        topicAll
    },
    created () {
        this.getQuestionTypeList();
        this.startExam();
    },
    computed: {
        showQuestionTypeList () {
            let arr = [];
            this.questionTypeList.map(type => {
                if (this.questionAllList[type.id].length > 0) {
                    arr.push(type);
                }
            });
            return arr;
        },
        allTopic () {
            let sum = null;
            for (let i = 1; i < this.questionAllList.length; i++) {
                sum += this.questionAllList[i].length;
            }
            return sum;
        }
    },
    methods: {
        startExam () {
            let { id } = this.$route.params;
            getEtexampaperDetail(id).then(res => {
                let { content } = res;
                let qList = { ...this.questionAllList };
                content = formatQuestions(content);
                content.map(item => {
                    qList[item.questionTypeId].push({
                        ...item
                    });
                });
                this.examInfo = {
                    ...res,
                    content
                };
                this.questionAllList = qList;
            });
        },
        getQuestionTypeList () {
            getEtquestiontypeList().then(res => {
                let oQuestions = {};
                res.map(type => {
                    oQuestions[String(type.id)] = [];
                });
                this.practiceType = String(res[0].id);
                this.questionAllList = oQuestions;
                this.questionTypeList = [...res];
            });
        },
        handleClick (i) {
            this.practiceType = i.name;
        }
    }
};
</script>

<style lang="less">
.test-preview {
    .preview-header {
        margin: 20px 0;
        padding: 20px 30px;
    }
    .preview-topic {
        margin-top: 10px;
        padding: 25px;
        .is-disabled {
            color: #14b14e;
        }
        .preview-topic-contant {
            p {
                display: inline-block;
            }
        }
        .el-radio__input.is-disabled + span.el-radio__label,
        .el-checkbox__input.is-disabled + span.el-checkbox__label {
            color: #666;
        }
        .el-radio__input.is-disabled.is-checked .el-radio__inner {
            background-color: #14b14e;
            border-color: #14b14e;
        }
        .el-radio__input.is-disabled .el-radio__inner::after {
            background-color: #fff;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner::after {
            border-color: #fff;
        }
        .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
            background-color: #14b14e;
        }
        &:hover {
            background-color: #f3faf8;
        }
        .question-completion {
            margin-top: 10px;
            span {
                margin-right: 10px;
            }
        }
        .questions-list {
            width: 100%;
            .choose-list {
                li {
                    margin-top: 10px;
                    padding: 10px 20px;
                    &:hover {
                        background-color: #d3e7ce;
                    }
                }
            }
        }
        .correct-answer {
            margin: 10px 0;
        }
    }
}
</style>

<style lang="less" scoped>
.test-preview {
    .preview-header {
        h1 {
            color: #666;
            text-align: center;
            font-weight: 400;
            border-bottom: 1px solid #000;
            padding-bottom: 10px;
        }
        p {
            margin-top: 20px;
            span {
                margin: 0;
                font-weight: 600;
            }
        }
    }
}
</style>

